module.exports = __webpack_public_path__ + "img/67f6d22da85e3882cd8ec9a0ade7d006.png";